import { useUser } from '@clerk/react';

const useRole = () => {
  const { user, isLoaded } = useUser();
  const role = user?.publicMetadata?.role ?? null;
  const isSuperAdmin = role === 'super_admin';
  return { role, isSuperAdmin, isLoaded };
};

export default useRole;
